import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { HREF, StorageService } from '@core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'lib-cookie-policy',
  templateUrl: './cookie-policy.component.html',
  styleUrl: './cookie-policy.component.scss',
  imports: [CommonModule, MatIconModule, RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CookiePolicyComponent {
  private storageService = inject(StorageService);
  private isCloseIconClicked = signal(false);
  readonly privacyPolicyPath = `/${HREF.INFO}/${HREF.PRIVACY_POLICY}`;
  hidden = computed(() => this.storageService.isCookiePolicyClosed || this.isCloseIconClicked());

  close(): void {
    this.storageService.isCookiePolicyClosed = true;
    this.isCloseIconClicked.set(true);
  }
}
